import { useTellescopeQuery } from "@tellescope/tanstack-query";
import type { ContentTypeData } from "../../../store/sidebar-store";
import {
  InformationSection,
  RelatedContactsSection,
  TimelineSection,
  TicketsSection,
  EventsSection,
  EligibilitySection,
  OrdersSection,
  EncountersSection,
  FilesSection,
  FormsSection,
  ContentSection,
  MedicationsSection,
  PaymentSection,
  VitalsSection,
} from "./sections";
import { Spinner, withKey } from "@tellescope/ui";

export type ContactDetailsSection =
  | "Information"
  | "RelatedContacts"
  | "Timeline"
  | "Tickets"
  | "Events"
  | "Eligibility"
  | "Orders"
  | "Encounters"
  | "Files"
  | "Forms"
  | "Content"
  | "Medications"
  | "Payment"
  | "Vitals";

export type ContactDetailsSidebarContentProps = NonNullable<ContentTypeData["ContactDetails"]>;

export const ContactDetailsSidebarContent = withKey(
  ({ enduserId, selectedSection }: ContactDetailsSidebarContentProps) => {
    const enduserQuery = useTellescopeQuery({
      model: "endusers",
      method: "getOne",
      request: enduserId,
      enabled: !!enduserId,
    });

    if (!enduserQuery.data) {
      return (
        <div className="flex items-center justify-center">
          <Spinner />
        </div>
      );
    }

    switch (selectedSection) {
      case "Information":
        return <InformationSection enduser={enduserQuery.data} />;
      case "RelatedContacts":
        return <RelatedContactsSection enduser={enduserQuery.data} />;
      case "Timeline":
        return <TimelineSection enduser={enduserQuery.data} />;
      case "Tickets":
        return <TicketsSection enduser={enduserQuery.data} />;
      case "Events":
        return <EventsSection enduser={enduserQuery.data} />;
      case "Eligibility":
        return <EligibilitySection enduser={enduserQuery.data} />;
      case "Orders":
        return <OrdersSection enduser={enduserQuery.data} />;
      case "Encounters":
        return <EncountersSection enduser={enduserQuery.data} />;
      case "Files":
        return <FilesSection enduser={enduserQuery.data} />;
      case "Forms":
        return <FormsSection enduser={enduserQuery.data} />;
      case "Content":
        return <ContentSection enduser={enduserQuery.data} />;
      case "Medications":
        return <MedicationsSection enduser={enduserQuery.data} />;
      case "Payment":
        return <PaymentSection enduser={enduserQuery.data} />;
      case "Vitals":
        return <VitalsSection enduser={enduserQuery.data} />;
    }
  },
  "enduserId"
);
